import ja                           from "date-fns/locale/ja";
import React, { FC }                from "react";
import ReactDatePicker              from "react-datepicker";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form, Icon }       from "semantic-ui-react";
import Date                         from "../../../../domain/fundamentals/date/Date";
import CustomerRecordRepository     from "../../../../domain/record/customer/CustomerRecordRepository";
import { ResKaState }               from "../../../../index";
import CustomerRecordDataSource
                                    from "../../../../infrastructure/datasource/record/customer/CustomerRecordDataSource";

const CustomerRecordDateButton: FC = () => {
  const date: Date = useSelector((state: ResKaState) => state.customerRecord.date);
  const repository: CustomerRecordRepository = new CustomerRecordDataSource(useDispatch());
  return (
    <>
      <Form>
        <Form.Field>
          <label>記録日</label>
          <ReactDatePicker
            withPortal
            dateFormat="YYYY/MM/DD"
            locale={ ja }
            onChange={ value => value ? repository.setCustomerRecordDate(Date.ofText(value.toString())) : date }
            customInput={
              <Button
                icon
                labelPosition="left"
              >
                <Icon name="calendar alternate outline"/>
                { date.asText() }
              </Button>
            }
          />
        </Form.Field>
      </Form>
    </>
  );
};

export default CustomerRecordDateButton;
